import React, { useEffect } from "react";
import { DatePicker, DayOfWeek, IMessageBarStyles, Label, MessageBar, MessageBarType } from "office-ui-fabric-react";
import { useField } from "formik";
import { useTranslation } from "react-i18next";
import { getDatePickerStrings } from "../../../commandBar/components/orders/datePicker.data";

const errorMessageS: IMessageBarStyles = {
    root: {
      marginTop: "15px",
      width: "100%",
    },
  };

interface IFormDatePickerProps {
  name: string;
  values: any;
  label?: string;
  required?: boolean;
  placeholder: string; 
}

const FormDatePicker: React.FC<IFormDatePickerProps> = ({
  name,
  values,
  label,
  required,
  placeholder
}) => {
  const { t } = useTranslation("admin");
  const [firstDayOfWeek, setFirstDayOfWeek] = React.useState(DayOfWeek.Monday);
  const [field, { value, error }, { setValue }] = useField(name);
  const [date, setDate] = React.useState<Date | null | undefined>(() => parseFormDate(value));

  const onSelectDate = (date: Date | null | undefined): void => {
    setDate(date);

    const formatedDate = onFormatDate(date);
    setValue(formatedDate);
  };
  const today: Date = new Date(Date.now());
  const onFormatDate = (date: any): any => {
    const formatedDate = `${date.getFullYear()}-${add0toDate(
      date.getMonth() + 1
    )}-${add0toDate(date.getDate())}`;

    return formatedDate;
  };

  return (
    <div >
      {label ? <Label required={required}>
        {label}
      </Label> : null}
      <DatePicker
        firstDayOfWeek={firstDayOfWeek}
        strings={getDatePickerStrings(t)}
        placeholder={placeholder}
        ariaLabel={t("nav.selectDate") as string}
        value={date!}
        onSelectDate={onSelectDate}
        formatDate={onFormatDate}
      />
      {error && (
        <MessageBar
          messageBarType={MessageBarType.error}
          isMultiline={false}
          dismissButtonAriaLabel={t("nav.close") as string}
          styles={errorMessageS}
        >
          {error}
        </MessageBar>
      )}
    </div>
  );
};

export default FormDatePicker;

const parseFormDate = (value: any): Date | null => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(typeof value === "string" ? value : "");
  return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
};

const add0toDate = (date: any) => {
  if (parseInt(date) < 10) {
    return `0${date}`;
  }

  return date;
};
